import gsap from "gsap";

export default class CursorController {
    constructor() {
        this.DOM = {
            cursorSection: ".js-custom-cursor",
            cursor: ".js-cursor",
            volumeButton: ".js-custom-video-player-volume-button",
            states: {
                play: ".js-cursor-play",
                pause: ".js-cursor-pause",
            },
        };
    }

    init() {
        this.cursorSection = document.querySelector(this.DOM.cursorSection);

        if (this.cursorSection) {
            this.cursorController();
        }
    }

    cursorController() {
        this.cursor = document.querySelector(this.DOM.cursor);
        this.playCursor = document.querySelector(this.DOM.states.play);
        this.pauseCursor = document.querySelector(this.DOM.states.pause);
        this.volumeButton = document.querySelector(this.DOM.volumeButton);

        if (
            this.cursor &&
            this.playCursor &&
            this.pauseCursor &&
            window.innerWidth > 800
        ) {
            this.cursorSection.addEventListener("mousemove", (e) => {
                gsap.to(this.cursor, {
                    left: e.offsetX,
                    top: e.offsetY,
                    ease: "Power4.easOut",
                    duration: 0.6,
                });

                // console.log(e);
            });

            this.cursorSection.addEventListener("mouseleave", () => {
                this.hideCursor();
            });

            this.cursorSection.addEventListener("mouseenter", () => {
                this.showCursor();
            });

            this.volumeButton.addEventListener("mouseenter", () => {
                this.hideCursor();
            });

            this.volumeButton.addEventListener("mouseleave", () => {
                this.showCursor();
            });
        }
    }

    play() {
        this.playCursor = document.querySelector(this.DOM.states.play);
        this.pauseCursor = document.querySelector(this.DOM.states.pause);

        if (this.playCursor && this.pauseCursor) {
            this.playCursor.style.display = "inline-flex";
            this.pauseCursor.style.display = "none";
        }
    }

    pause() {
        this.playCursor = document.querySelector(this.DOM.states.play);
        this.pauseCursor = document.querySelector(this.DOM.states.pause);

        console.log(this.playCursor, this.pauseCursor);
        if (this.playCursor && this.pauseCursor) {
            this.playCursor.style.display = "none";
            this.pauseCursor.style.display = "inline-flex";
        }
    }

    hideCursor() {
        gsap.to(this.cursor, {
            autoAlpha: 0,
            ease: "Power4.easOut",
            duration: 0,
        });
    }

    showCursor() {
        gsap.to(this.cursor, {
            autoAlpha: 1,
            ease: "Power4.easOut",
            duration: 0.2,
            delay: 0.2,
        });
    }
}
